import React from "react";
import { useTranslation } from "utilities/i18n";
import { useModalDispatch, ModalForm } from "collections/Modal";
import {
  ProvisioningAccount,
  SubmitFn,
  ProvisioningFormContent,
  UpdateProvisioningAccountSchema
} from "./ProvisioningSettings";

export const EditServerCredentialsModal: React.FC<{
  account: ProvisioningAccount;
  submit: SubmitFn;
}> = ({ account, submit }) => {
  const { t } = useTranslation();
  const dispatchEvent = useModalDispatch();

  return (
    <ModalForm
      title={t("EDIT_SERVER_CREDENTIALS")}
      className="pt-2"
      name="EditProvisioningCredentials"
      onSubmit={values =>
        submit(values, true, t("SERVER_CREDENTIALS_UPDATED"), () =>
          dispatchEvent()
        )
      }
      initialValues={{
        username: account.username ?? "",
        password: "",
        confirmPassword: ""
      }}
      enableReinitialize
      validationSchema={UpdateProvisioningAccountSchema}
    >
      {({ handleReset, isSubmitting, dirty, isValid, field }) => {
        const disabled = isSubmitting || !dirty || !isValid;
        return (
          <ProvisioningFormContent
            disabled={disabled}
            handleReset={handleReset}
            field={field}
            isNew={false}
            isSubmitting={isSubmitting}
            onReset={dispatchEvent}
          />
        );
      }}
    </ModalForm>
  );
};
